import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import { deleteCreditProfile } from 'app-components/flux/credit-profile/actions';
import { getCreditProfile } from 'app-components/flux/credit-profile/selectors';
import { rootUiActions, rootUiSelectors } from 'app-components/flux/root-ui';

import StdDialog from 'components/Dialogs/StdDialog';
import QButton from 'components/QButton';

import {
  CREDIT_REPORT_CANCEL_REGISTRATION_ID,
  CREDIT_SCORE_VERIFICATION_DIALOG_ID,
  CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID,
} from './actions';
import styles from './styles';

// @ts-expect-error FIXME TS2345
const useStyles = makeStyles()(styles);

const CreditScoreLoadingDialog: React.FC = () => {
  const { classes } = useStyles();
  const creditProfileData = useSelector(getCreditProfile);
  const activeModals: Record<string, any>[] = useSelector(rootUiSelectors.getActiveModalsAsJS);
  const dispatch = useDispatch();

  const handleDialogAction = (action: string) => {
    if (action === 'yes') {
      dispatch(rootUiActions.removeDialog(CREDIT_REPORT_CANCEL_REGISTRATION_ID));
      const verificationModalIndex = activeModals.findIndex(
        (modal) => modal.id === CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID,
      );
      if (verificationModalIndex >= 0) {
        dispatch(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID));
      }
      dispatch(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
      dispatch(deleteCreditProfile({ creditProfileRegistrationId: creditProfileData?.id }));
    } else {
      dispatch(rootUiActions.removeDialog(CREDIT_REPORT_CANCEL_REGISTRATION_ID));
    }
  };

  return (
    <StdDialog
      onClose={() => handleDialogAction('no')}
      open
      size='xs'
      disableBackdropClick
      title={'Cancel Verification'}
    >
      <DialogContent>
        <Typography variant='paragraphRegular'>{'Are you sure you want to cancel the verification?'}</Typography>
      </DialogContent>
      <DialogActions>
        <QButton
          className={classes.btnDialogAction}
          variant={'delete'}
          onClick={() => handleDialogAction('yes')}
          id='credit-score-flow-cancel-btn'
        >
          Yes, Cancel
        </QButton>
        <QButton
          className={classes.btnDialogAction}
          variant={'contained'}
          onClick={() => handleDialogAction('no')}
          id='credit-score-flow-dont-cancel-btn'
        >
          {"No, Don't Cancel"}
        </QButton>
      </DialogActions>
    </StdDialog>
  );
};

export default CreditScoreLoadingDialog;
